import React from 'react';
import PaymentEdit from './PaymentEdit';
import PaymentReceipt from './PaymentReceipt';
import { paymentDeleteStyle } from './paymentStyles';
export default function PaymentActions({jobId,receipt,payment,onSaved,onDelete,deleting=false}:{
  jobId:string;receipt?:any;payment?:any;onSaved:()=>any;onDelete?:()=>any;deleting?:boolean;
}) {
  return <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',justifyContent:'flex-end'}}>
    <PaymentReceipt jobId={jobId} receipt={receipt} paymentId={payment?.id} url={receipt?.check_image_url || payment?.attachment_url} onSaved={onSaved}/>
    <PaymentEdit jobId={jobId} receipt={receipt} payment={payment} onSaved={onSaved}/>
    {onDelete && <button type="button" onClick={onDelete} disabled={deleting} aria-label={`Delete payment ${payment?.payment_number || receipt?.check_number || ''}`} style={paymentDeleteStyle}>{deleting?'Deleting…':'Delete'}</button>}
  </div>;
}
